export default class MenuDesignSystem {
    constructor(element){
        this.element = element;
        this.options = {
            rootMargin: '-35% 0px -40% 0px',
        }

        this.init();
    }

    init(){
        const observer = new IntersectionObserver(
            this.watch.bind(this),
            this.options
        )

        let sections = document.querySelectorAll(".js-ds-section");
        for(let i = 0; i < sections.length; i++){
            let section = sections[i];
            observer.observe(section);
        }
    }

    watch(entries){
        for(let i = 0; i < entries.length; i++){
            const entry = entries[i];
            const target = entry.target;
            let id = target.id;

            if (entry.isIntersecting){
                document.querySelector(".js-" + id).classList.add("active");
            }
            else{
                document.querySelector(".js-" + id).classList.remove("active");
            }
        }
    }
}